export default "__VITE_ASSET__B$Q5UjiU__"